import { atom } from "recoil";
import { KeyboardShortcut, hotkeyTabs, hotkeySections, triggerTypes } from "../Types/KeyboardShortcut";

export const generalShortcutsAtom = atom({
    key: "generalShortcuts",
    default: [] as KeyboardShortcut[],
})

export const annotationShortcutsAtom = atom({
    key: "annotationShortcuts",
    default: [] as KeyboardShortcut[],
})

export const EVENT_REVIEW_SHORTCUTS: KeyboardShortcut[] = [
    { id: "event-review-next", title: "Next annotation", action: "", deletable: false, section: hotkeySections.NAVIGATION, tab: hotkeyTabs.GENERAL, triggers: ["]", null] },
    { id: "event-review-prev", title: "Previous annotation", action: "", deletable: false, section: hotkeySections.NAVIGATION, tab: hotkeyTabs.GENERAL, triggers: ["[", null] },
    { id: "event-review-play", title: "Play through annotation", action: "", deletable: false, section: hotkeySections.NAVIGATION, tab: hotkeyTabs.GENERAL, triggers: ["p", null] },
    { id: "event-review-jump", title: "Jump to current annotation", action: "", deletable: false, section: hotkeySections.NAVIGATION, tab: hotkeyTabs.GENERAL, triggers: ["j", null] },
]

export const hotkeysEnabledAtom = atom<boolean>({
    key: "hotkeysEnabled",
    default: true
})

export function updateHotkeyTrigger(config: KeyboardShortcut, triggerType: string, newTrigger: string) {
    switch(triggerType) {
        case triggerTypes.PRIMARY:
            config.triggers[0] = newTrigger
            break;
        case triggerTypes.SECONDARY:
            config.triggers[1] = newTrigger
            break;
        default:
            throw new Error("Bad trigger type: " +  triggerType)
    }

    return config
}

export const loadHotkeysFromConfigs = (hotkeyConfigs: KeyboardShortcut[]) => {
    return hotkeyConfigs.map((config: KeyboardShortcut, index: number) => {
        // Create a new object to avoid mutating read-only Recoil values
        const id = config.id || `TEMP-${Math.random()}-${Date.now()}}-${index}`
        
        // Ensure triggers array has exactly 2 elements
        const triggers: [string | null, string | null] = [
            config.triggers[0] ?? null,
            config.triggers[1] ?? null
        ]

        // Create new data object if it exists
        const data = config.data ? {
            ...config.data,
            id: id
        } : undefined

        return {
            ...config,
            id,
            triggers,
            data
        }
    })
}
